/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Three-letter ISO currency code, in uppercase. Must be a supported currency.
 */
export const ProductCurrency = {
  Eur: "EUR",
  Usd: "USD",
} as const;
/**
 * Three-letter ISO currency code, in uppercase. Must be a supported currency.
 */
export type ProductCurrency = ClosedEnum<typeof ProductCurrency>;

/** @internal */
export const ProductCurrency$inboundSchema: z.ZodNativeEnum<
  typeof ProductCurrency
> = z.nativeEnum(ProductCurrency);
/** @internal */
export const ProductCurrency$outboundSchema: z.ZodNativeEnum<
  typeof ProductCurrency
> = ProductCurrency$inboundSchema;
